export enum AppHtmlId {
    LOADING = 'sails-loading-spinner',
    ACCORDION_FAQ = 'faq-accordion',
    DYNAMIC_FOOTNOTE = 'fiber-footnote-accordion',
    APP_CONTAINER = 'fiber-app-container',
    ERROR = 'fiber-service-error',
    WHICH_FIBER_TABS = 'fixnet-fiber-tabs',
    RELATED_LINKS = 'fiber-related-links',
    RELATED_LINKS_OFFERS = 'fiber-related-links-offers',
    SUMMARY_CARD = 'fixnet-offer-summary-card',
    ALT_SUMMARY_CARD = 'fiber-pdp-alternative-result',
    SEAL_IMG = 'fixnet-seal-product',
    LINEAR_STEPPER = 'fixnet-linear-stepper',
    FNF_ACCORDION = 'ws10-accordion-item-details-fnf-footnote',
}

export enum SummaryCardHtmlId {
    TARIFF_SUBLINE_TOOLTIP = 'fiber-selected-tariff-subline-tooltip',
    LEGAL_TEXT_TOOLTIP = 'fiber-legal-text-tooltip',
    HIGHLIGHT_BADGE_TOOLTIP = 'badge-tooltip',
    LOGGED_STATE = 'fiber-unlogged-link',
    // DIPO 4160
    ALTERNATIVE_RESULT_WRAPPER = 'fiber-pdp-alternative-result',
    // TODO: replace ID with "summary card update"
    ALTERNATIVE_RESULT_BUTTON = 'fiber-pdp-button-alternative',
}

export enum FloatingButtonId {
    FLOATING_NOTIFICATION = 'floating-mobile-notification',
    FLOATING_BUTTON = 'floatin-notification-button',
    FlayOutIcon = '.contact-flyout__drawer',
    AnchorIcon ='.mod.mod-anchortop.mod-smooth-anchor-scroll.anchorShown a'
}

export enum TariffHtmlId {
    TARIFF_PICKER = 'fiber-tariff-picker',
    BENEFITS = 'fiber-tariff-benefits',
    BENEFITS_LIST = 'fiber-tariff-benefits-list',
    LINKS_LIST = 'fiber-tariff-links-list'
}

export enum AvcHtmlId {
    CHECK_CONTAINER = 'fiber-avc-container',
    RESULT_CONTAINER = 'fiber-avc-result-container'
}

export enum CheckModuleHtmlId {
    MODULE_CONTAINER = 'fiber-check-container',
    BUTTON_LINK = 'fiber-check-text-link-wrapper'
}

export enum LMModuleHtmlId {
    MODULE_CONTAINER = 'fiber-lm-module-container',
    MODULE_SUCCESS_CONTAINER = 'fiber-lm-module-success-container',
    BUTTON_LINK = 'fiber-lm-text-link-wrapper'
}

export enum AddressHtmlId {
    ADDRESS_WRAPPER = 'fiber-checked-address',
    ADDRESS_TEXT = 'fiber-avc-address',
    CHANGE_ADDRESS = 'fiber-change-address-button',
    DELETE_ADDRESS = 'fiber-delete-address-button'
}

export enum DiscountHtmlId {
    GIGAKOMBI_ICON_TEXT = 'fiber-gigakombi-icon-text',
    GIGAKOMBI_PICKER = 'fiber-gigakombi-picker',
    GIGAKOMBI_PICKER_TEXT = 'fiber-gigakombi-picker-additional-text',
    GIGAKOMBI_DISCOUNT_CARD = 'gigakombi-discount-card',
    PROMOTIONAL_INFO_CARD = 'fixnet-wholybuy-card',
    GIGAKOMBI_DISCOUNT_CARD_TOOLTIP = 'gigakombi-discount-card-tooltip',
}

export enum ResultHtmlId {
    NOTIFICATION = 'avc-notification',
    ALTERNATIVE_TEXT = 'avc-alternative-text',
    BUTTON = 'avc-button',
    CHECKED_ADDRESS = 'avc-checked-address',
    TOOLTIP = 'avc-regiofee-tooltip',
    CHANGE_ADDRESS = 'avc-change-address-button',
    LM_BUTTON = 'avc-lm-form-open-button',
    // DIPO-4160
    ALTERNATIVE_WRAPPER = 'avc-alternative-container',
    SECOND_ALTERNATIVE_TEXT = 'avc-second-alternative-text',
    ALTERNATIVE_BUTTON = 'avc-alternative-button',
}

export enum LmsHtmlId {
    WRAPPER_FORM_LMS = 'wrapper-lms-form-section',
    WRAPPER_INPUT_GENDER = 'wrapper-input-lms-gender',
    WRAPPER_INPUT_FIRSTNAME = 'wrapper-input-lms-firstname',
    WRAPPER_INPUT_LASTNAME = 'wrapper-input-lms-lastname',
    WRAPPER_INPUT_EMAIL = 'wrapper-input-lms-email',
    WRAPPER_BTN_LMS_SUBMIT = 'wrapper-btn-lms-submit',
    WRAPPER_NOTIFICATION_RESULT = 'wrapper-notification-lms-result',
    WRAPPER_NOTIFICATION_ERROR = 'wrapper-notification-lms-error',
    WRAPPER_BTN_LMS_BACK = 'wrapper-btn-lms-back'
}

export enum FormId {
    FORM = 'avc-form',
    CITY = 'wrapper-input-avc-city',
    STREET = 'wrapper-input-avc-street',
    NUMBER = 'wrapper-input-avc-house',
    SUBMIT = 'wrapper-btn-address-form',
    LOADING = 'avc-loading-spinner',
    SELECT_CONTAINER = 'avc-select-container',
    SELECT = 'avc-select-wrapper',
    TOOLTIP = 'avc-subline-tooltip',
    ADDRESS_ERROR = 'avc-address-error',
    SERVICE_ERROR = 'avc-service-error'
}

export type HtmlId = AppHtmlId |
    FloatingButtonId |
    TariffHtmlId |
    DiscountHtmlId |
    AddressHtmlId |
    ResultHtmlId |
    LMModuleHtmlId |
    LmsHtmlId |
    CheckModuleHtmlId |
    AvcHtmlId |
    FormId |
    SummaryCardHtmlId;

export enum OverlayContent {
    FORM = 'avc-address-form',
    CAPTCHA = 'avc-captcha',
    RESULT = 'avc-result-container',
    LMS_MODULE = 'lms-module-container'
}
